import { type AdvisorCountryParams, advisorCountryParams } from '~/utils/advisorCountry'

export function useAdvisorCountryParams() {
  const country = useState<AdvisorCountryParams>('advisor-country', () => ({}))
  const route = useRouter().currentRoute.value
  if (route.path.startsWith('/web-report/') || 'reportAccessToken' in route.query) {
    return {}
  }
  return advisorCountryParams(country.value)
}
